/* eslint-disable angular/controller-as */
angular.
module("digiexam").
controller("DxCreateClassController", function CreateClassController(
	$scope,
	group,
	dxDialog,
	faults,
	dxLocalize
) {
	"use strict";
	$scope.createClassInProgress = false;
	$scope.isError = false;
	$scope.errorMessage = "";

	$scope.cancelCreateClass = function cancelCreateClass() {
		dxDialog.closeMostRecent();
	};

	$scope.canSubmit = function canSubmit() {
		if ($scope.createClassInProgress || !$scope.classTitle || $scope.classTitle.length < 2) {
			return false;
		}
		return true;
	};

	$scope.createClass = function createClass(title) {
		if (!$scope.canSubmit()) {
			return;
		}

		$scope.isError = false;
		$scope.createClassInProgress = true;

		var classCreatePromise = group.create(title);
		classCreatePromise.then(function handleResponse(response) {
			$scope.createClassInProgress = false;
			if (response.faults) {
				$scope.isError = true;
				if (response.faults.indexOf(faults.NAME_NOT_ALLOWED) >= 0) {
					$scope.errorMessage = dxLocalize.get("TheNameIsNotAllowed");
				} else {
					$scope.errorMessage = dxLocalize.get("UnknownError");
				}
			} else {
				$scope.finishCreateClass(response.id);
				dxDialog.closeMostRecent();
			}
		});
	};
});
